<div class="form form-horizontal">
    <div class="form-row">
        @if (selectedThemeButtonFont(); as buttonFont) {
            <div class="form-group mb-20">
                <div class="col-xs-12">
                    <label>{{ "control_text_style" | translate }}</label>
                    <a class="dotted pull-right" (click)="openFontSettings()">{{ "edit" | translate }}</a>
                </div>
                <div class="col-xs-12">
                    <div class="well well-sm mb-0 small text-muted">
                        {{ "button_text_style_hint" | translate }}
                        <samp>{{ FONT_FAMILIES[buttonFont.font].name }}</samp>
                    </div>
                </div>
            </div>
        }

        <sp-custom-button-v2
            [base]="base()"
            [hover]="hover()"
            [colorsPreset]="colorsPreset()"
            (valueChange)="valueChangeEvent.emit($event)"
        />
    </div>
</div>
